<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle class="d-flex align-center pb-2">
      <v-icon small color="primary" class="mr-2">mdi-silverware-fork-knife</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("attachment_meal") }}</span>
    </v-card-subtitle>
    <v-card-text>
      <template v-for="(group, index) in groupByCategory">
        <autocomplete
          :label="toLatin(index)"
          v-model="selectedSideDishes"
          :items="group"
          dense
          :placeholder="$t('attachment_meal')"
          return-object
          :item-text="(dish) => toLatin(dish.name)"
          item-value="id"
          outlined
          multiple
          chips
          deletable-chips
          small-chips
          hide-details
          @input="onSideDishesChange"
        ></autocomplete>
      </template>
    </v-card-text>
    <br>
    <v-card-text class="pt-0">
      <!-- <autocomplete
        v-model="selectedSideDishes"
        :items="attachmentM"
        dense
        :placeholder="$t('attachment_meal')"
        return-object
        item-text="name"
        item-value="id"
        outlined
        multiple
        chips
        deletable-chips
        small-chips
        hide-details
        @input="onSideDishesChange"
      ></autocomplete> -->
      <v-divider
        class="my-2"
        v-if="editedItem.prilog && editedItem.prilog.length"
      ></v-divider>
      <div v-if="editedItem.prilog && editedItem.prilog.length">
        <div
          v-for="(group, index) in groupedPrilozi"
          :key="group.categoryName"
          class="category-group"
        >
          <div class="category-header">
            <span class="category-title">{{ toLatin(group.categoryName) }} <span class="category-count">({{ group.items.length }} stavki)</span></span>
            <v-checkbox
              v-model="group.mandatory"
              label="Obavezan Prilog"
              @change="setMaxOrder(group)"
              hide-details
            />
            <text-field
              v-model="group.max_order"
              type="number"
              dense
              outlined
              hide-details
              label="Maksimalni broj stavki"
              @input="setMaxOrder(group)"
              style="max-width: 160px; margin-left: 8px;"
            />
          </div>

          <div
            v-for="(dish, idx) in group.items"
            :key="dish.id"
            class="grocery-item"
          >
            <span class="flex-grow-1 text-body-2">{{ toLatin(dish.name) }}</span>
            <template v-if="editedItem.is_package && dish.pivot">
              <text-field
                v-model="dish.pivot.extra_price"
                type="number"
                min="0"
                hide-details
                :label="$t('food_package.extra_price')"
                :suffix="$store.state.restaurant.settings?.price || ''"
                class="package-field"
              />
              <text-field
                v-model="dish.pivot.min_order"
                type="number"
                hide-details
                :label="$t('food_package.min_order')"
                class="package-field package-field--narrow"
              />
              <text-field
                v-model="dish.pivot.max_order"
                type="number"
                hide-details
                :label="$t('food_package.max_order')"
                class="package-field package-field--narrow"
              />
            </template>
            <remove-button @click="removePrilog(dish)" />
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import mealService from "@/services/meal";
import hasSnackbar from "@/mixins/hasSnackbar";
import textField from '../../../../global/fields/text-field.vue';
import axios from "../../../../../plugins/axios";

export default {
  components: { textField },
  mixins: [hasSnackbar],
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    sideDishes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedSideDishes: [],
    sideDishes2: [],
    loading: false,
  }),
  created() {
    this.loadSideDishes();
    this.initializeSelections();
  },
  methods: {
    setMaxOrder(group) {
      axios.put(`/categories/${group.id}`, { max_order: group.max_order, mandatory: group.mandatory })
        .then(() => {
          this.showSuccessSnackbar('Max order updated successfully');
        })
        .catch((error) => {
          console.error("Error setting max order:", error);
          this.showErrorSnackbar('Error updating max order');
        });
    },
    loadSideDishes() {
      this.loading = true;
      mealService
        .getSideDishes()
        .then((res) => {
          this.sideDishes2 = res.data;
        })
        .catch((error) => {
          console.error("Error loading side dishes:", error);
          this.showErrorSnackbar(this.$t("error_loading_side_dishes"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initializeSelections() {
      this.selectedSideDishes = [...(this.editedItem.prilog || [])];
    },
    onSideDishesChange(selected) {
      if (!this.editedItem.prilog) {
        this.editedItem.prilog = [];
      }
      // Add newly selected side dishes at the top
      selected.forEach((dish) => {
        const exists = this.editedItem.prilog.find((p) => p.id === dish.id);
        if (!exists) {
          this.editedItem.prilog.unshift({
            ...dish,
            pivot: { quantity: 0, extra_price: 0, min_order: null, max_order: null },
          });
        }
      });

      // Remove deselected side dishes
      this.editedItem.prilog = this.editedItem.prilog.filter((p) =>
        selected.some((s) => s.id === p.id)
      );
    },
    removePrilog(item) {
      const index = this.editedItem.prilog.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        this.editedItem.prilog.splice(index, 1);
        this.selectedSideDishes = [...this.editedItem.prilog];
      }
    },
  },
  computed: {
    groupedPrilozi() {
      // Prvo grupišemo po category.name
      const groupedMap = {};

      this.editedItem.prilog.forEach(item => {
        const categoryName = item.category?.name || 'Bez kategorije';

        if (!groupedMap[categoryName]) {
          groupedMap[categoryName] = {
            categoryName: categoryName,
            items: [],
            max_order: item.category?.max_order || null,
            id: item.category?.id || null
          };
        }

        groupedMap[categoryName].items.push(item);
      });

      // Konvertujemo u niz objekata
      const result = Object.values(groupedMap);

      // Opciono: dodaj max_order za svaku grupu (npr. iz nekog izvora)
      // Ako imaš max_order negde definisan, možeš ga dodati
      result.forEach(group => {
        // Primer: ako imaš neku mapu sa max_order po kategoriji
        // group.max_order = this.categoryOrderMap[group.categoryName] || null;

        // Ili ako želiš da izračunaš max po nekom polju iz items
        // group.max_order = Math.max(...group.items.map(item => item.order || 0));
      });

      // Opciono: sortiranje po nazivu kategorije
      result.sort((a, b) => a.categoryName.localeCompare(b.categoryName));

      return result;
    },
    groupByCategory() {
      return this.attachmentM.reduce((acc, item) => {
        const categoryName = item.category?.name;
        if(!categoryName) return acc

        // Ako još ne postoji niz za ovu kategoriju, kreiramo ga
        if (!acc[categoryName]) {
          acc[categoryName] = [];
        }

        // Dodajemo ceo objekat u odgovarajuću grupu
        acc[categoryName].push(item);

        return acc;
      }, {});
    },
    attachmentM() {
      const attachmentMeals = [...this.sideDishes, ...this.sideDishes2];
      if (!this.editedItem || !this.editedItem.prilog) {
        return attachmentMeals || [];
      }
      return this.editedItem?.prilog
        ? (attachmentMeals || []).filter(
            (item) =>
              !this.editedItem.prilog.some((side) => side.id === item.id) && item?.id
          )
        : attachmentMeals;
    },
  },
  watch: {
    "editedItem.prilog": {
      handler(newVal) {
        if (newVal) {
          this.selectedSideDishes = [...newVal];
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.grocery-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.grocery-item:last-child {
  border-bottom: none;
}

.grocery-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}


.category-group {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-title {
  font-weight: 600;
  font-size: 1.1em;
  color: #333;
}

.category-count {
  font-size: 0.85em;
  color: #666;
}

.max-order-badge {
  background: #4CAF50;
  color: white;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.8em;
  font-weight: 500;
}

.grocery-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 8px;
  margin: 4px 0;
  border-radius: 4px;
  transition: background 0.2s;
}

.grocery-item:hover {
  background: #f5f5f5;
}

.item-order {
  font-size: 0.75em;
  color: #999;
  background: #f0f0f0;
  padding: 0 6px;
  border-radius: 3px;
}

.flex-grow-1 {
  flex: 1;
}

.package-field {
  width: 120px;
  flex-shrink: 0;
}

.package-field--narrow {
  width: 90px;
}

.text-body-2 {
  font-size: 0.9em;
}

</style>
